import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);


export function initResponsiveTables() {
  // Add wrapper to all tables
  $('table').wrap('<div class="table-wrapper js-scroll-table-when-in-screen"></div')


  // animate table scroll when in screen
  document.querySelectorAll('.js-scroll-table-when-in-screen').forEach(function (el) {
    if ($(el).find('table').width() > window.innerWidth) {
      ScrollTrigger.create({
        trigger: el,
        start: "top bottom", // el top, screen bottom
        once: true,
        onEnter: () => animateTableScroll(el)
      });
    }
  })

}


export function animateTableScroll(el){
  if ($(el).find('table').width() > window.innerWidth) {
    $(el).find('table').delay(400).animate({ left: '-80px' }, 600,
      function () {
        $(this).animate({ left: 0 }, 600)
      })
  }
}
